<div class="flex-container gap-12" style="height: 100%">
  <vl-widget-title
    [text]="'dashboard_ui.w_nc_stats' | trans"
    [accent]="(displayData()?.analytics?.totalCount ?? 0) + ' NC'"
    [widget]="widget()"
    [draggable]="true">
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>
    @if (showPeriodFilter()) {
      <vl-widget-period-filters
        [(timeScale)]="timeScale"
        [showPeriod]="false"
        [showComparison]="false"/>
    }
  </vl-widget-title>

  @if (isLoading() && !displayData()) {
    <div class="flex-row gap-16 widget-content">
      <div>
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{'height': '160px', 'width': '160px', 'background-color': 'var(--color-on-disabled)'}"/>
      </div>
      <div class="h100 w100 overflow-hidden">
        <ngx-skeleton-loader count="6" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
      </div>
    </div>
  } @else if (hasData()) {
    <div class="flex-col w100 widget-content fade-in" style="overflow: hidden; gap: 8px">
      <!-- 3 KPI mini chips en haut (Ouvertes / Critiques / Taux échappées) -->
      <div class="flex-row gap-8">
        <div class="kpi-mini grow">
          <span class="caption-2 on-background-alt">{{ 'dashboard_ui.nc_kpi_ouvertes' | trans }}</span>
          <span class="subheading-2">{{ displayData()?.stats?.ouvertes ?? 0 }}</span>
        </div>
        <div class="kpi-mini grow" [class.kpi-critique]="(displayData()?.stats?.critiquesOuvertes ?? 0) > 0">
          <span class="caption-2 on-background-alt">{{ 'dashboard_ui.nc_kpi_critiques' | trans }}</span>
          <span class="subheading-2">{{ displayData()?.stats?.critiquesOuvertes ?? 0 }}</span>
        </div>
        <div class="kpi-mini grow" [matTooltip]="'dashboard_ui.nc_kpi_taux_echappees_hint' | trans">
          <span class="caption-2 on-background-alt">{{ 'dashboard_ui.nc_kpi_taux_echappees' | trans }}</span>
          <span class="subheading-2">{{ tauxEchappees() }}</span>
        </div>
      </div>

      <!-- Donut origine + légende inline (pattern valeur-par-famille) -->
      <div class="flex-row w100 grow" style="overflow: hidden; min-height: 0">
        <div class="h100 overflow-hidden grow" style="min-width: 0">
          <canvas #origineChart></canvas>
        </div>
        <div class="flex-col shrink-0 justify-between" style="max-width: 160px; padding-top: 4px">
          <div class="flex-col gap-2">
            <span class="caption on-background-alt">{{ 'dashboard_ui.nc_titre_origine' | trans }}</span>
            @for (l of origineLabels(); track l.label) {
              <div class="flex-row gap-4 p-2 align-center">
                <span [style.background-color]="l.color" class="border-full shrink-0" style="width: 8px; height: 8px"></span>
                <span class="grow tiny on-background-alt" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ ('dashboard_ui.' + l.label) | trans }}</span>
                <span class="tiny on-disabled shrink-0">{{ l.count }} ({{ l.percentage }}%)</span>
              </div>
            }
          </div>
          <vl-chips state="active" size="small" iconRight="open_in_new" (action)="openFullList()">
            {{ 'button.see_all' | trans }}
          </vl-chips>
        </div>
      </div>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>
